import React from 'react'
import axios from "axios"
import { enqueueSnackbar } from "notistack"
import { Link } from 'react-router-dom';
import { hostNameBack } from '../../utils/constants';
import Loader from '../../utils/Loader';

function Categories() {

    const [productCats, setProductCats] = React.useState(null);
    const [serviceCats, setServiceCats] = React.useState(null);
    const [isLoading, setIsLoading] = React.useState(true);

    React.useEffect(() => {

        axios.get(`${hostNameBack}/api/v1/categories/all`)
        .then(response => {
            if (response.data.success) {
                setProductCats(response.data.productCategories);
                setServiceCats(response.data.serviceCategories);
            }
                else
                    enqueueSnackbar("Something went wrong!", { variant: "error" });
            })
            // .catch(e => {
            //     enqueueSnackbar(e.response?.data?.error || "Something went wrong!", { variant: "error" })
            // })
            .finally(()=>{
                setIsLoading(false);
            })
    }, [])

    const allProductCats = productCats ? productCats.map((category, index) => {
        return <Link key={index} to={`/products?categories=${encodeURIComponent(category.name)}`} className='category'>
            <p>{category.name} <span className='count'>({category.count})</span></p>
            <i className="fa-solid fa-arrow-right"></i>
        </Link>
    }) : [];

    const allServiceCats = serviceCats ? serviceCats.map((category, index) => {
        return <Link key={index} to={`/services?categories=${encodeURIComponent(category.name)}`} className='category'>
            <p>{category.name} <span className='count'>({category.count})</span></p>
            <i className="fa-solid fa-arrow-right"></i>
        </Link>
    }) : [];

    if(isLoading) return <Loader type="simpleMax" />

    return (
        <div className='categoriesDiv'>

                <div className="categoriesContent">

                    <div className="productCatsDiv">
                        <img src="./assets/images/product_categories.svg" alt="Categories" className='categoriesBanner selectDisable' draggable={false} />
                        <div className="categories">
                            {allProductCats}
                        </div>
                    </div>

                    <div className="serviceCatsDiv">
                        <img src="./assets/images/service_categories.svg" alt="Categories" className='categoriesBanner selectDisable' draggable={false} />
                        <div className="categories">
                            {allServiceCats}
                        </div>
                    </div>

                </div>

        </div>
    )
}

export default Categories